import React, { createContext, ReactNode } from 'react';

type CommunicationProps = object;

const defaultContextValue = {};

export const CommunicationContext =
  createContext<CommunicationProps>(defaultContextValue);

const CommunicationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => (
  <CommunicationContext.Provider value={defaultContextValue}>
    {children}
  </CommunicationContext.Provider>
);

export default CommunicationProvider;
